
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { isPlatformBrowser } from '@angular/common';

export const accessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  const allowedRoles = route.data['roles'] as Array<string>;
  let userRole = authService.userRoleId(); 
  if (userRole === 'guest' && isPlatformBrowser(platformId) ) {
    const storedUser = localStorage.getItem('Admin_User');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      userRole = parsed.data?.role?.id || parsed.data?.role;
    }
  }
  if (userRole === 'super_admin') return true;
  if (allowedRoles && allowedRoles.includes(userRole)) {
    return true;
  }
  return router.navigate(['/unauthorized']);
};
